export default "__VITE_ASSET__9e34ab30__"